import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { FC } from 'react'
import { Colors, Shapes } from 'src/components/theme'
import { formatVal } from 'src/utils/number-format'
import { ParcelTypeChip } from 'src/v2/components/parcel-type-chip'

const Container = styled.div`
  flex: 1;
`

const Row = styled.div`
  display: flex;
  border-bottom: 1px solid ${Colors.neutral100};
  padding: 12px 0;
  gap: ${Shapes.spacing[4]}px;
  :last-of-type {
    border-bottom: none;
  }
`

const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`
const FirstColumn = styled(Column)`
  flex: 2;
`

export type RowItem = {
  type: string
  value: number | string
  percentage: number
}

type TableProps = {
  data: RowItem[]
  valueHeader: string
}

export const Table: FC<TableProps> = ({ data, valueHeader }) => {
  return (
    <Container>
      <Row>
        <FirstColumn>
          <Typography variant="textmdm" color={Colors.neutral500}>
            Property Type
          </Typography>
        </FirstColumn>
        <Column>
          <Typography variant="textmdm" color={Colors.neutral500}>
            {valueHeader}
          </Typography>
        </Column>
        <Column>
          <Typography variant="textmdm" color={Colors.neutral500}>
            % of Portfolio
          </Typography>
        </Column>
      </Row>
      {data.map((item, index) => (
        <Row key={index}>
          <FirstColumn>
            <ParcelTypeChip type={item.type} />
          </FirstColumn>
          <Column>
            <Typography variant="textmd" color={Colors.neutral800}>
              {item.value}
            </Typography>
          </Column>
          <Column>
            <Typography variant="textmd" color={Colors.neutral800}>
              {formatVal(item.percentage, 'percentage')}
            </Typography>
          </Column>
        </Row>
      ))}
    </Container>
  )
}
